// extracted by mini-css-extract-plugin
module.exports = {"page-comp":"A_page-comp__6e5u8"};